import { useState } from "react";
import Promotions from "@/pages/marketing/Promotions";
import { CampaignComposer } from "@/components/marketing/CampaignComposer";
import { usePromotions } from "@/hooks/sms/usePromotions";

/** The Campaign tab of /marketing: the promotions list is the landing state;
 *  "Launch campaign" / "Send" swaps it for the composer in place (the tab
 *  keeps its URL, so Back simply returns to the list). */
export default function CampaignTab({ storeId }: { storeId: string }) {
  const [composing, setComposing] = useState(false);
  const [composerPromotionId, setComposerPromotionId] = useState<string | null>(null);
  const { data: activePromotions = [] } = usePromotions({ status: "active" });

  if (composing) {
    return (
      <CampaignComposer
        storeId={storeId}
        promotions={activePromotions}
        initialPromotionId={composerPromotionId}
        onBack={() => setComposing(false)}
      />
    );
  }

  return (
    <Promotions
      storeId={storeId}
      onLaunch={(promotionId) => {
        setComposerPromotionId(promotionId);
        setComposing(true);
      }}
    />
  );
}
